<mat-card>
  <mat-card-header>
    <mat-card-title class="popupHeader">
      <div class="mat-card-header-text" i18n>
        Permissions
      </div>        
    </mat-card-title> 
  </mat-card-header>

<mat-card-content>
<div>
  <table class="mat-table" >
    <tr class="mat-header-row">
      <th class="mat-header-cell"></th>
      <th class="mat-header-cell" i18n>Access</th>
      <th class="mat-header-cell" i18n>Visible</th>
    </tr>
    <tr class="mat-row ">
      <td class="mat-cell">
        <div fxLayout="row">
          <div>
            <mat-icon><img src="assets/images/building_PopUp_label_256_cs_mobile.png" alt=""></mat-icon>
          </div>
          <div class="mimg" i18n>
            Building
          </div>
        </div>
      </td>
      <td class="mat-cell"><mat-slide-toggle color="primary" [checked]="isBuildingAccessChecked" disabled="true"></mat-slide-toggle></td>
      <td class="mat-cell"><mat-slide-toggle class="toggleVisibilityBtn" color="primary" [checked]="isBuildingViewChecked" disabled="true"></mat-slide-toggle></td>
    </tr>
    <tr class="mat-row">
      <td class="mat-cell"> <div fxLayout="row">
        <div>
          <mat-icon><img src="assets/images/trench_PopUp_label_256_cs_mobile.png" alt=""></mat-icon>
        </div>
        <div class="mimg" i18n>
          Trench
        </div>
      </div>
    </td>
      <td class="mat-cell"><mat-slide-toggle color="primary" [checked]="isTrenchAccessChecked" disabled="true"></mat-slide-toggle></td>
      <td class="mat-cell"><mat-slide-toggle class="toggleVisibilityBtn" color="primary" [checked]="isTrenchViewChecked" disabled="true"></mat-slide-toggle></td>
    </tr>
    <tr class="mat-row">
      <td class="mat-cell"> <div fxLayout="row">
        <div>
          <mat-icon><img src="assets/images/duct_PopUp_label_256_cs_mobile.png" alt=""></mat-icon>
        </div>
        <div class="mimg" i18n>
          Duct
        </div>
      </div></td>
      <td class="mat-cell"><mat-slide-toggle color="primary" [checked]="isDuctAccessChecked" disabled="true"></mat-slide-toggle></td>
      <td class="mat-cell"><mat-slide-toggle class="toggleVisibilityBtn" color="primary" [checked]="isDuctViewChecked" disabled="true"></mat-slide-toggle></td>
    </tr>
    <tr class="mat-row">
      <td class="mat-cell"> <div fxLayout="row">
        <div>
          <mat-icon><img src="assets/images/cable_PopUp_label_256_cs_mobile.png" alt=""></mat-icon>
        </div>
        <div class="mimg" i18n>
          Cable
        </div>
      </div></td>
      <td class="mat-cell"><mat-slide-toggle color="primary" [checked]="isCableAccessChecked" disabled="true"></mat-slide-toggle></td>
      <td class="mat-cell"><mat-slide-toggle class="toggleVisibilityBtn" color="primary" [checked]="isCableViewChecked" disabled="true"></mat-slide-toggle></td>
    </tr>
    <tr class="mat-row">
      <td class="mat-cell"> <div fxLayout="row">
        <div>
          <mat-icon><img src="assets/images/customerservice_PopUp_label_256_cs_mobile.png" alt=""></mat-icon>
        </div>
        <div class="mimg" i18n>
          Service
        </div>
      </div></td>
      <td class="mat-cell"><mat-slide-toggle color="primary" disabled="true"></mat-slide-toggle></td>
      <td class="mat-cell"><mat-slide-toggle class="toggleVisibilityBtn" color="primary" checked="true" disabled="true"></mat-slide-toggle></td>
    </tr>
    <tr class="mat-row">
      <td class="mat-cell"> <div fxLayout="row">
        <div>
          <mat-icon><img src="assets/images/redliningV3_icon_default256_ label_icons.png" alt=""></mat-icon>
        </div>
        <div class="mimg" i18n>
          Redlining
        </div>
      </div></td>
      <td class="mat-cell"><mat-slide-toggle color="primary" [(ngModel)]="isRedAccessChecked"></mat-slide-toggle></td>
      <td class="mat-cell"><mat-slide-toggle class="toggleVisibilityBtn" color="primary" (change)="updatepermissionChange($event)"  [(ngModel)]="isRedViewChecked"></mat-slide-toggle></td>
    </tr>
  </table>
</div>
  </mat-card-content>
</mat-card>
